import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';

@Injectable()
export class DocumentVerificationService {
  private apiUrl = environment.apiUrl;
  private existsByDocTypeAndNumberUrl = `${this.apiUrl}origination/originations/exists-account-by-document/{docType}/{docNumber}`;
  private validateDocNumberUrl = `${this.apiUrl}origination/validation/validate-document-number/{docNumber}`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public existsByDocTypeAndNumber(docType: number, docNumber: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(
      this.existsByDocTypeAndNumberUrl.replace('{docType}', docType.toString()).replace('{docNumber}', docNumber),
      { headers: this.headers }
    );
  }

  public validateDocNumber(docNumber: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(this.validateDocNumberUrl.replace('{docNumber}', docNumber), { headers: this.headers });
  }
}
